<template>
  <div>
    <div v-if="this.company" class="menu-items">
      <a
       href="/finance/bank_report"
        class="cardTransactions cursor-pointer"
        :class="this.menuSelected.bank_report && 'cardTransactions-active'"
        >{{ $t("finance.bankReportName") }}</a
      >
      <a 
      href="/finance/client_mandate"
      class="contact cursor-pointer"
        :class="this.menuSelected.client_mandate && 'contact-active'"
        >{{ $t("finance.clientMandateName") }}</a
      >
      <a 
      href="/finance/payment"
      class="services cursor-pointer"
        :class="this.menuSelected.payments && 'services-active'"
        >{{ $t("finance.paymentsName")  }}</a
      >
      <a
      href="/finance/account"
      class="amanage cursor-pointer"
        :class="this.menuSelected.account && 'amanage-active'"
        >{{ $t("settingsName") }}</a
      >
      <a href="#" class="logout" @click="logout()">{{ $t("logoutName") }}</a>
    </div>
    <div class="socials">
      <a href="https://www.facebook.com/UpRomania" class="facebook"></a>
      <a
        href="https://www.linkedin.com/company/up-romania"
        class="linkedin"
      ></a>
      <a
        href="https://www.youtube.com/c/UpRomaniaBucuresti"
        class="youtube"
      ></a>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";

export default {
  name: "MenuItemsFinance",
  props: {
    company: Object,
    menuSelected: {
      search: false,
      beneficiary: false,
      account: false,
      jsmComplaint: false,
      flexben: false,
    },
    user: Object
  },
  methods: {
    logout() {
      this.logoutCompany(this.user.id, Cookies.get("token"));
      Cookies.remove("user_data");;
      Cookies.remove("selectedBeneficiary");
      sessionStorage.removeItem('selectedCompany');
      Cookies.remove("selectedCompany");
      Cookies.remove("userLink");
      Cookies.remove("user_role");
      Cookies.remove("token");
      this.$router.push({
        name: "login",
        params: { loginUserSelected: false }
      });
      this.$emit("sendUserRole", "", "");
    },
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    }
  },
};
</script>
<style scoped src="@/assets/styles/beneficiary.css"></style>
